(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3002],{

/***/ 66377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ PostAuthor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _common_Typography_Typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20026);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_hi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53854);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89583);





const SocialLink = (param)=>/*#__PURE__*/ {
    let { href , icon  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: href,
        className: "transition-colors text-copy-on-dark",
        target: "_blank",
        rel: "noreferrer",
        children: icon
    });
};
function PostAuthor(param) {
    let { profilePhoto , firstName , lastName , title , hidePhoto , personalWebsiteLink , twitterLink , githubLink , hideTitle , linkedInLink  } = param;
    var _url;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex gap-3",
        children: [
            !hidePhoto && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "overflow-hidden rounded-full w-12 h-12 border-solid border-[3px] border-divider-on-dark relative",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: (_url = profilePhoto.url) !== null && _url !== void 0 ? _url : "",
                    layout: "fill",
                    alt: "author picture",
                    objectFit: "cover"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col items-start",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_common_Typography_Typography__WEBPACK_IMPORTED_MODULE_1__/* .Typography */ .Z, {
                                type: "copy3",
                                emphasis: true,
                                children: [
                                    firstName,
                                    " ",
                                    lastName
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-wrap gap-2 pointer-events-auto",
                                children: [
                                    personalWebsiteLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SocialLink, {
                                        href: personalWebsiteLink,
                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_3__/* .HiGlobeAlt */ .lKz, {})
                                    }),
                                    twitterLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SocialLink, {
                                        href: twitterLink,
                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_4__/* .FaTwitter */ .fWC, {})
                                    }),
                                    githubLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SocialLink, {
                                        href: githubLink,
                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_4__/* .FaGithub */ .hJX, {})
                                    }),
                                    linkedInLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SocialLink, {
                                        href: linkedInLink,
                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_4__/* .FaLinkedin */ .ltd, {})
                                    })
                                ]
                            })
                        ]
                    }),
                    !hideTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_Typography_Typography__WEBPACK_IMPORTED_MODULE_1__/* .Typography */ .Z, {
                        type: "copy4",
                        className: "text-copy-on-dark",
                        children: title
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 75517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cx": function() { return /* binding */ getTagUrl; },
/* harmony export */   "Md": function() { return /* binding */ PostTag; },
/* harmony export */   "N_": function() { return /* binding */ TagTab; }
/* harmony export */ });
/* unused harmony export SidebarTag */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_hi__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53854);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8193);
/* harmony import */ var react_icons_io__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51649);
/* harmony import */ var _common_Typography_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20026);







const getTagUrl = (slug)=>slug === "all" || !slug ? "/blog" : "/blog/tag/".concat(slug);
function TagIcon(param) {
    let { slug , className  } = param;
    const iconMap = {
        all: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_4__/* .HiCollection */ .CAn, {
            className: className
        }),
        "highlight-engineering": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_4__/* .HiCog */ .oq2, {
            className: className
        }),
        "developer-tooling": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_4__/* .HiTerminal */ .Zbf, {
            className: className
        }),
        "session-replay": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_4__/* .HiPlay */ .bKy, {
            className: className
        }),
        "debugging-and-troubleshooting": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_5__/* .AiFillBug */ .zax, {
            className: className
        }),
        "performance-monitoring": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_6__/* .IoIosStopwatch */ .M66, {
            className: className
        }),
        "frontend-monitoring": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_4__/* .HiChartPie */ .twD, {
            className: className
        })
    };
    var _slug;
    return (_slug = iconMap[slug]) !== null && _slug !== void 0 ? _slug : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_4__/* .HiTag */ .IFg, {
        className: className
    });
}
function PostTag(param) {
    let { name , slug  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: getTagUrl(slug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "rounded-full bg-white/[12%] w-fit px-3 py-0.5 select-none cursor-pointer hover:bg-copy-on-light transition-colors active:bg-black/25 active:transition-none text-copy-on-dark",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_Typography_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .Z, {
                type: "copy4",
                children: name
            })
        })
    });
}
function SidebarTag(param) {
    let { name , slug , current  } = param;
    return /*#__PURE__*/ _jsx(Link, {
        href: getTagUrl(slug),
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex gap-[3px] items-center text-copy-on-dark h-[30px] select-none cursor-pointer transition-all active:transition-none group hover:bg-divider-on-dark/30 active:bg-dark-background pl-[3px]",
            children: [
                /*#__PURE__*/ _jsx(TagIcon, {
                    slug: slug,
                    className: classNames("transition-all  group-hover:text-copy-on-dark", current ? "text-white" : "text-copy-on-light")
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    type: "copy3",
                    className: classNames("transition-all group-hover:opacity-100 group-hover:text-copy-on-dark", current ? "text-white opacity-100" : "opacity-70"),
                    emphasis: current,
                    children: name
                })
            ]
        })
    });
}
function TagTab(param) {
    let { name , slug , current  } = param;
    const tabBaseStyle = classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex gap-2 flex-0 items-center h-[30px] select-none box-content cursor-pointer hover:opacity-100 transition-opacity active:opacity-50 active:transition-none leading-none px-1 pb-2 group border-b-2 border-0 border-solid");
    const tabColorStyle = classnames__WEBPACK_IMPORTED_MODULE_1___default()(current ? "text-highlight-yellow border-highlight-yellow" : "text-copy-on-dark border-transparent");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: getTagUrl(slug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(tabBaseStyle, tabColorStyle),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(current ? "text-highlight-yellow" : "opacity-70 group-hover:opacity-100 transition-opacity", "mt-1"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TagIcon, {
                        slug: slug
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_Typography_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .Z, {
                    type: "copy2",
                    className: "w-max",
                    emphasis: current,
                    children: name
                })
            ]
        })
    });
}


/***/ }),

/***/ 90170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Blog": function() { return /* binding */ Blog; },
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ blog; },
  "loadPostsFromHygraph": function() { return /* binding */ loadPostsFromHygraph; },
  "loadTagsFromHygraph": function() { return /* binding */ loadTagsFromHygraph; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography = __webpack_require__(20026);
// EXTERNAL MODULE: ./components/common/Navbar/Navbar.tsx + 4 modules
var Navbar = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/common/CallToAction/FooterCallToAction.tsx + 1 modules
var FooterCallToAction = __webpack_require__(24035);
// EXTERNAL MODULE: ./components/common/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(5945);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(28687);
// EXTERNAL MODULE: ./node_modules/react-icons/hi/index.esm.js
var index_esm = __webpack_require__(53854);
// EXTERNAL MODULE: ./components/Blog/Tag.tsx
var Tag = __webpack_require__(75517);
;// CONCATENATED MODULE: ./utils/graphql.ts
/* provided dependency */ var process = __webpack_require__(34155);

const graphcms = new dist.GraphQLClient("https://api-us-west-2.graphcms.com/v2/cl2tzedef0o3p01yz7c7eetq8/master", {
    headers: {
        Authorization: "Bearer ".concat(process.env.GRAPHCMS_TOKEN)
    },
    fetch
});
const GraphQLRequest = async function(doc, variables) {
    let delay = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if ( true && delay) {
        // delay hygraph requests during prerendering to avoid too many concurrent requests
        await new Promise((r)=>setTimeout(r, Math.random() * 5000));
    }
    return await graphcms.request(doc, variables);
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/match-sorter/dist/match-sorter.esm.js
var match_sorter_esm = __webpack_require__(90233);
// EXTERNAL MODULE: ./components/Blog/Author.tsx
var Author = __webpack_require__(66377);
// EXTERNAL MODULE: ./components/Blog/Blog.module.scss
var Blog_module = __webpack_require__(50848);
var Blog_module_default = /*#__PURE__*/__webpack_require__.n(Blog_module);
;// CONCATENATED MODULE: ./pages/blog/index.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query GetPosts() {\n        posts(\n          orderBy: postedAt_DESC\n          where: { unlisted: false }\n          ) {\n            slug\n            title\n            publishedAt\n            postedAt\n            readingTime\n            featured\n            image {\n              url\n            }\n            author {\n              firstName\n              lastName\n              title\n              twitterLink\n              linkedInLink\n              githubLink\n              personalWebsiteLink\n              profilePhoto {\n                url\n              }\n            }\n            tags_relations {\n              name\n              slug\n            }\n          }\n      }\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetTags() {\n      tags {\n        name\n        description\n        slug\n      }\n    }\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}


















var __N_SSG = true;
async function loadPostsFromHygraph(tag) {
    const QUERY = (0,dist.gql)(_templateObject());
    const { posts  } = await GraphQLRequest(QUERY, {
        tag: tag ? [
            tag
        ] : []
    });
    return posts.filter((p)=>tag ? p.tags_relations.some((t)=>t.slug === tag) : true);
}
async function loadTagsFromHygraph() {
    const tagsQuery = (0,dist.gql)(_templateObject1());
    return (await GraphQLRequest(tagsQuery)).tags;
}
const allTag = {
    name: "All posts",
    slug: "all",
    description: "Welcome to the Highlight Blog, where the Highlight team talks about frontend engineering, observability and more!"
};
// https://usehooks-ts.com/react-hook/use-debounce
function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0,react.useState)(value);
    (0,react.useEffect)(()=>{
        const timer = setTimeout(()=>setDebouncedValue(value), delay || 500);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
const Blog = (param)=>{
    let { posts , tags , currentTagSlug  } = param;
    var _page;
    const pageQuery = (_page = (0,router.useRouter)().query.page) !== null && _page !== void 0 ? _page : "1";
    let page = 1;
    if (Array.isArray(pageQuery)) page = parseInt(pageQuery[0]);
    else page = parseInt(pageQuery);
    const shownTags = [
        allTag,
        ...tags
    ];
    var ref;
    const currentTag = (ref = tags.find((param)=>{
        let { slug  } = param;
        return slug === currentTagSlug;
    })) !== null && ref !== void 0 ? ref : allTag;
    const [searchQuery, setSearchQuery] = (0,react.useState)("");
    const debouncedSearchQuery = useDebounce(searchQuery, 300);
    const itemsPerPage = 4;
    const shouldFeature = !debouncedSearchQuery && currentTag.slug === allTag.slug && page <= 1;
    const filteredPosts = debouncedSearchQuery ? (0,match_sorter_esm/* matchSorter */.Lu)(posts, debouncedSearchQuery, {
        keys: [
            "title",
            {
                key: "tags_relations.name",
                maxRanking: match_sorter_esm/* matchSorter.rankings.CONTAINS */.Lu.rankings.CONTAINS
            }
        ]
    }) : posts;
    page = Math.ceil(Math.min(page, filteredPosts.length / itemsPerPage));
    const displayedPosts = debouncedSearchQuery ? filteredPosts : filteredPosts.slice(itemsPerPage * (page - 1), itemsPerPage * page);
    const isStartupStack = currentTag.slug.includes("stack");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-row w-full gap-8 my-20 desktop:max-w-[1100px] mx-auto items-start px-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            /* Main Side */ className: "flex flex-col flex-1 w-full gap-11",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    /* Category Description */ className: "flex flex-col items-start gap-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            children: isStartupStack ? "Welcome to the Startup Stack!" : currentTag.name
                                        }),
                                        isStartupStack ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                                            className: (Blog_module_default()).copyOnDark,
                                            type: "copy1",
                                            children: [
                                                "This is where we talk about the tools and tech you can use to build your next Startup! Read through our episodes below or find us",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "https://www.youtube.com/channel/UCATzQs36Mo7Cezt5Ij9ayZQ",
                                                    children: "on YouTube"
                                                }),
                                                "."
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy1",
                                            className: (Blog_module_default()).copyOnDark,
                                            children: currentTag.description || allTag.description
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    /* Search and Posts */ className: "flex flex-col gap-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            /* Tags Tabs */ className: "flex gap-8 overflow-x-scroll scrollbar-hidden",
                                            children: shownTags.map((tag)=>/*#__PURE__*/ (0,react.createElement)(Tag/* TagTab */.N_, {
                                                    ...tag,
                                                    key: tag.slug,
                                                    current: currentTag.slug === tag.slug
                                                }))
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            /* Search and Pagination */ className: "flex flex-col justify-between w-full gap-4 mobile:flex-row",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                /* Search */ className: "flex items-center flex-grow gap-1 px-2 transition-colors border rounded-lg text-copy-on-dark border-divider-on-dark focus-within:border-copy-on-light h-11",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HiOutlineSearch */.O6C, {
                                                        className: "w-5 h-5 text-copy-on-light"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        placeholder: currentTag.slug === "all" ? "Search all posts..." : "Search all ".concat(currentTag.name, " posts..."),
                                                        value: searchQuery,
                                                        onChange: (ev)=>setSearchQuery(ev.currentTarget.value),
                                                        className: "h-full flex-1 leading-none bg-transparent outline-none text-copy-on-dark text-[17px] w-0"
                                                    })
                                                ]
                                            })
                                        }),
                                        displayedPosts.map((post)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: isStartupStack ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EpisodeItem, {
                                                    post: post
                                                }, post.slug) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PostItem, {
                                                    post: post
                                                }, post.slug)
                                            });
                                        }),
                                        displayedPosts.length < 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy2",
                                            className: "my-10 text-center text-copy-on-light",
                                            children: "No Posts Found"
                                        }),
                                        displayedPosts.length > 0 && !debouncedSearchQuery && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageController, {
                                            page: page,
                                            count: filteredPosts.length / itemsPerPage,
                                            tag: currentTag.slug
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterCallToAction/* FooterCallToAction */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
function PageController(param) {
    let { page , count , tag  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-row items-center self-center h-9",
        children: [
            page <= 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                type: "copy3",
                emphasis: true,
                className: "grid h-full w-[94px] border border-current rounded-l-md place-items-center text-copy-on-light select-none",
                children: "Previous"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "".concat((0,Tag/* getTagUrl */.Cx)(tag), "?page=").concat(page - 1 || 1),
                className: "grid h-full w-[94px] border border-current rounded-l-md place-items-center",
                children: "Previous"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                type: "copy3",
                className: "grid h-full px-3 border-y text-copy-on-light border-divider-on-dark place-items-center",
                children: [
                    page,
                    " / ",
                    Math.ceil(count)
                ]
            }),
            page >= Math.ceil(count) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                type: "copy3",
                emphasis: true,
                className: "grid h-full w-[94px] border border-current rounded-r-md place-items-center text-copy-on-light select-none",
                children: "Next"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "".concat((0,Tag/* getTagUrl */.Cx)(tag), "?page=").concat(page + 1 || 1),
                className: "grid h-full w-[94px] border border-current rounded-r-md place-items-center",
                children: "Next"
            })
        ]
    });
}
function getDateAndReadingTime(postedAt, readingMinutes) {
    const postedDate = new Date(postedAt).toLocaleDateString(undefined, {
        month: "short",
        day: "numeric",
        year: "numeric"
    });
    return "".concat(postedDate, " • ").concat(readingMinutes, " min. read");
}
const postItemStyle = classnames_default()("relative w-full gap-3 transition-colors border border-solid rounded-lg bg-dark-background p-7 hover:bg-divider-on-dark border-divider-on-dark hover:border-copy-on-light");
const EpisodeItem = (param)=>{
    let { post  } = param;
    var ref, ref1;
    const firstTag = post.tags_relations[0];
    var _readingTime, _readingTime1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden mobile:block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "row",
                        border: "1px solid #30294E",
                        padding: 24,
                        borderRadius: 8,
                        gap: 24
                    },
                    children: [
                        (post === null || post === void 0 ? void 0 : (ref = post.image) === null || ref === void 0 ? void 0 : ref.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            style: {
                                borderRadius: 8,
                                border: "2px solid #30294E",
                                height: 100 * 1.5,
                                width: 190 * 1.5
                            },
                            src: (ref1 = post.image) === null || ref1 === void 0 ? void 0 : ref1.url,
                            alt: "podcast image",
                            height: 100,
                            width: 190
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    type: "copy4",
                                    className: "text-copy-on-dark",
                                    children: getDateAndReadingTime(post.postedAt, (_readingTime = post.readingTime) !== null && _readingTime !== void 0 ? _readingTime : 0)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/blog/".concat(post.slug),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        className: "mt-1",
                                        children: post.title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-3",
                                    children: post.author ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Author/* PostAuthor */.M, {
                                        hideTitle: true,
                                        hidePhoto: true,
                                        ...post.author
                                    }) : "Missing Post Author!"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("mobile:hidden block"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        border: "1px solid #30294E",
                        padding: 24,
                        borderRadius: 8,
                        gap: 24
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            firstTag && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* PostTag */.Md, {
                                ...firstTag
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/blog/".concat(post.slug),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "mt-3",
                                    children: post.title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                type: "copy4",
                                className: "mt-1 text-copy-on-dark",
                                children: getDateAndReadingTime(post.postedAt, (_readingTime1 = post.readingTime) !== null && _readingTime1 !== void 0 ? _readingTime1 : 0)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-6",
                                children: post.author && /*#__PURE__*/ (0,jsx_runtime.jsx)(Author/* PostAuthor */.M, {
                                    ...post.author,
                                    hidePhoto: true
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
const PostItem = (param)=>{
    let { post , feature: featured = false  } = param;
    var ref;
    const firstTag = post.tags_relations[0];
    var _readingTime, _readingTime1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()(postItemStyle, featured && "shadow-[8px_8px_0_0_#5420D1]", "hidden mobile:block"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/blog/".concat(post.slug),
                        className: "absolute inset-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        type: "copy4",
                        className: "text-copy-on-dark",
                        children: getDateAndReadingTime(post.postedAt, (_readingTime = post.readingTime) !== null && _readingTime !== void 0 ? _readingTime : 0)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        className: "mt-1",
                        children: post.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative mt-3 pointer-events-none",
                        children: post.author && /*#__PURE__*/ (0,jsx_runtime.jsx)(Author/* PostAuthor */.M, {
                            ...post.author
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex gap-2.5 absolute right-7 bottom-7",
                        children: (ref = post.tags_relations) === null || ref === void 0 ? void 0 : ref.map((tag)=>/*#__PURE__*/ (0,react.createElement)(Tag/* PostTag */.Md, {
                                ...tag,
                                key: tag.slug
                            }))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()(postItemStyle, featured && "shadow-[8px_8px_0_0_#5420D1]", "mobile:hidden block"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/blog/".concat(post.slug),
                        className: "absolute inset-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                    }),
                    firstTag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* PostTag */.Md, {
                            ...firstTag
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "mt-3",
                        children: post.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        type: "copy4",
                        className: "mt-1 text-copy-on-dark",
                        children: getDateAndReadingTime(post.postedAt, (_readingTime1 = post.readingTime) !== null && _readingTime1 !== void 0 ? _readingTime1 : 0)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative mt-6 pointer-events-none",
                        children: post.author && /*#__PURE__*/ (0,jsx_runtime.jsx)(Author/* PostAuthor */.M, {
                            ...post.author,
                            hidePhoto: true
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var blog = (Blog);


/***/ }),

/***/ 50848:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blogContainer":"Blog_blogContainer__RcYz1","blogSection":"Blog_blogSection__ob5ix","tagContainer":"Blog_tagContainer__Ca1se","copyOnDark":"Blog_copyOnDark__icLCO","tagHeader":"Blog_tagHeader__koSPS","suggestedBlogPost":"Blog_suggestedBlogPost__5cjSY","cardImage":"Blog_cardImage__XNHLl","cardSection":"Blog_cardSection__b1BFz","suggestedPostTitle":"Blog_suggestedPostTitle__BL5A7","blogPost":"Blog_blogPost___Voip","blogPostSmall":"Blog_blogPostSmall__glYdY","postDateDiv":"Blog_postDateDiv__CpP7p","tagDiv":"Blog_tagDiv__4TCOb","bodyText":"Blog_bodyText___VbtI","avatar":"Blog_avatar__lmA0z","authorDiv":"Blog_authorDiv__OfWDl","authorDescription":"Blog_authorDescription__LHLkW","authorDetails":"Blog_authorDetails__FRlgF","mainBlogPadding":"Blog_mainBlogPadding__fAxBt","mainImage":"Blog_mainImage__io3SO","youtubeEmbed":"Blog_youtubeEmbed__YfQbH","tagSortTitle":"Blog_tagSortTitle__Wn_4G","selectedTag":"Blog_selectedTag__UFOjS","dateDiv":"Blog_dateDiv__eBLrY","postTagDiv":"Blog_postTagDiv___Yc8e","suggestedPostDiv":"Blog_suggestedPostDiv__9_6Vh","suggestedPost":"Blog_suggestedPost__xTA8q","postBodyTop":"Blog_postBodyTop__UvyVH","headerSection":"Blog_headerSection__DLrZP","postBody":"Blog_postBody__v_Dyg","codeBlock":"Blog_codeBlock__KCkc2","codeInline":"Blog_codeInline__1fz_b","postBodyDivider":"Blog_postBodyDivider__4_LDF","otherArticlesHeader":"Blog_otherArticlesHeader__Qz5m8","blogImageContainer":"Blog_blogImageContainer__107eO","blogImage":"Blog_blogImage__Kb_Mj","blogText":"Blog_blogText__MlX8v"};

/***/ })

}]);